<section class="reports__top-container">
  <section class="card table-container">
    <app-public-flow-chart [data]="publicFlow$ | async" />
  </section>
  <section class="card table-container">
    <app-validated-tickets-table [data]="(validatedTikcets$ | async) || []" />
  </section>
</section>
